import { ImportHistoryFilters } from './components/ImportHistoryFilters';
import { ImportHistoryTable } from './components/ImportHistoryTable';
import {
  useImportHistory,
  type ImportHistoryProps
} from './hooks/useImportHistory';

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function ImportHistoryPage(props: ImportHistoryProps) {
  const {
    loading,
    tableData,
    filters,
    showClearFilterBtn,
    names,
    columns,
    dateInFilter,
    orderStatusRef,
    uploadByRef,
    dateInputElement,
    handleFilterChange,
    clearFilter,
    isProperty
  } = useImportHistory(props);

  return (
    <section className="flex min-h-0 flex-1 flex-col">
      {tableData.length > 0 && (
        <ImportHistoryFilters
          isProperty={isProperty}
          names={names}
          dateInFilter={dateInFilter}
          showClearFilterBtn={showClearFilterBtn}
          orderStatusRef={orderStatusRef}
          uploadByRef={uploadByRef}
          dateInputElement={dateInputElement}
          handleFilterChange={handleFilterChange}
          clearFilter={clearFilter}
        />
      )}

      <div className="flex min-h-0 flex-1 flex-col">
        <ImportHistoryTable
          loading={loading}
          columns={columns}
          tableData={tableData}
          filters={filters}
        />
      </div>
    </section>
  );
}

/** Keep named export for backwards compatibility */
export { ImportHistoryPage as ImportHistory };
